import React from 'react';
import PropTypes from 'prop-types';
import appnexus from './appnexus';

const FallbackProvider = props => (
  <props.baseProvider>{props.children}</props.baseProvider>
);

FallbackProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

const fallback = {
  provider: FallbackProvider,
  container: () => null,
};

export const AD_SERVICES = {
  appnexus: Object.assign({}, fallback, appnexus),
  fallback,
};

export const getAdService = service =>
  AD_SERVICES[service] || AD_SERVICES.fallback;

export default {
  AD_SERVICES,
  getAdService,
};
